import { SocketTopics } from "../constants/enums"
import  useSocketService from  '../hooks/useSocketService';

export default (): ISocket=>{

    const {socketClient, socketConnect,  socketSubscribeToEvent, socketPublishToEvent, socketUnSubscribeToEvent, subscribeToEventUser, publishToEventUser, publishToEventServiceIdUser}  = useSocketService();

    const subscribeToEvent = (topic: SocketTopics, subscriptionPath: string, callback=()=>{})=>{    
      socketSubscribeToEvent(topic, subscriptionPath, callback)
    };

    const unSubscribeToEvent = (topic: SocketTopics, subscriptionPath: string, callback=()=>{})=>{    
      socketUnSubscribeToEvent(topic, subscriptionPath, callback)
    };

    const publishToEvent = (topic: SocketTopics, subscriptionPath: string, payload: IPublishWrapRequest | IPublishRequest, callback=()=>{})=>{    
        socketPublishToEvent(topic, subscriptionPath, payload, callback)
      };

      const subscribeToUser = (
        event: SocketTopics,
        topic: string,
        callback = () => {}
      ) => {
        subscribeToEventUser(event, topic, callback);
      };
    
      const publishToUser = (
        event: SocketTopics,
        topic: string,
        payload: IPublishRequest,
        subscribePath: string,
        callback = () => {}
      ) => {
        publishToEventUser(event, topic, payload, subscribePath, callback);
      };
    
      const publishToServiceIdUser = (
        event: SocketTopics,
        topic: string,
        payload: IPublishRequest,
        subscribePath: string,
        serviceId: string,
        callback = () => {}
      ) => {
        publishToEventServiceIdUser(
          event,
          topic,
          payload,
          subscribePath,
          serviceId,
          callback
        );
      };

      return {
          client: socketClient,
          subscribeToEvent, 
          subscribeToUser,
          publishToUser,
          publishToServiceIdUser,
          publishToEvent,
          unSubscribeToEvent,
          connect: socketConnect
      }
}